import isString from "../../common-utils/string/isString.util.js";
// This util makes it easier to omit props from a styled component
export const shouldForwardPropUtil = (...propNames) => (prop) => isString(prop) ? !propNames.includes(prop) : true;
export default shouldForwardPropUtil;
